import { render, staticRenderFns } from "./agencyShopManage.vue?vue&type=template&id=bad72d20&scoped=true&"
import script from "./agencyShopManage.vue?vue&type=script&lang=js&"
export * from "./agencyShopManage.vue?vue&type=script&lang=js&"
import style0 from "./agencyShopManage.vue?vue&type=style&index=0&id=bad72d20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad72d20",
  null
  
)

component.options.__file = "agencyShopManage.vue"
export default component.exports